/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-pascal-case */
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import ArrowForward from '@material-ui/icons/NavigateNext';
import ArrowBackward from '@material-ui/icons/NavigateBefore';
import LoginForm from './LoginForm';
import './LoginPage.scss';

export default (options = {}) => {
  const {
    adminLogin,
    useAdminLogin,
    adminLoginTitle = 'Sign in',
    adminLinkText = 'Administrator Sign in',
    adminLoginButtonText = 'Sign in as administrator',
    userLoginTitle = 'Sign in',
    userLinkText = 'User Sign in',
    userLoginButtonText = 'Sign in',
  } = options;

  const LoginPage = (props) => {
    const { authService, location = {}, title } = props;
    const [from] = useState(() => (location.state && location.state.referrer || { pathname: '/' }));
    const [username] = useState(() => authService.getLastUsername());
    const [admin, setAdmin] = useState(false);
    const [SwipeableViews, setSwipeableViews] = useState(null);
    const allowAdminLogin = useAdminLogin ? useAdminLogin(props) : adminLogin;

    useEffect(() => {
      async function loadLib() {
        setSwipeableViews(await import(/* webpackChunkName: "react-swipeable-views" */ 'react-swipeable-views'));
      }
      loadLib();
    }, []);

    const handleSubmit = useCallback(({ username: u, password: p, admin: a }) => {
      return authService.authenticate(u, p, a);
    }, [authService]);

    const handlePageSwipe = useCallback((e) => {
      e.preventDefault();
      setAdmin(!admin);
    }, [admin]);

    if (!SwipeableViews) {
      return (null);
    }

    return (
      <div className="grb-login-page">
        <div className="grb-login-side-panel">
          <div className="grb-login-side-panel-content">
            <div className="grb-gurobi-logo" />
            <Typography variant="h5">{title}</Typography>
          </div>
        </div>
        <div className={classnames('grb-login-page-main', allowAdminLogin && 'grb-login-page-main-swipe')}>
          <div className="grb-login-page-main-content">
            {allowAdminLogin ? (
              <React.Fragment>
                <Link
                  component="button"
                  onClick={handlePageSwipe}
                  id="grb-login-switch-admin-user"
                  variant="body"
                  className="grb-button-no-uppercase"
                >
                  {admin && <ArrowBackward className="grb-gutter-right" />}
                  {admin ? userLinkText : adminLinkText}
                  {!admin && <ArrowForward className="grb-gutter-left" />}
                </Link>
                <SwipeableViews.default
                  className="grb-login-page-swipeable-comps"
                  axis="x"
                  index={admin ? 1 : 0}
                  disabled
                >
                  <LoginForm
                    username={username}
                    onSubmit={handleSubmit}
                    title={userLoginTitle}
                    loginButtonText={userLoginButtonText}
                    focus={!admin}
                    from={from}
                    active={!admin}
                  />
                  <LoginForm
                    username={username}
                    onSubmit={handleSubmit}
                    title={adminLoginTitle}
                    loginButtonText={adminLoginButtonText}
                    from={from}
                    focus={admin}
                    admin
                    active={admin}
                  />
                </SwipeableViews.default>
              </React.Fragment>
            ) : (
              <LoginForm
                username={username}
                onSubmit={handleSubmit}
                title={userLoginTitle}
                loginButtonText={userLoginButtonText}
                from={from}
              />
            )}
          </div>
        </div>
      </div>
    );
  };

  LoginPage.propTypes = {
    authService: PropTypes.shape({
      getLastUsername: PropTypes.func.isRequired,
      authenticate: PropTypes.func.isRequired,
    }).isRequired,
    title: PropTypes.string,
    location: PropTypes.shape({}),
  };

  LoginPage.defaultProps = {
    location: undefined,
    title: 'Gurobi',
  };

  return LoginPage;
};
